import React from "react";
import './Footer1.css';
import picture1 from './source/picture1.png'
import picture2 from './source/picture2.png'
import picture3 from './source/picture3.png'
import picture4 from './source/picture4.png'
import {Link} from "react-router-dom"


function Footer1() {

  return (
    <div className="footer1">
      <div className="footer1-box1">
        <div className="footer1-box2">

          <div className="footer1-box3">
            <div className="footer1-box4">O NÁS</div>
            <div className="footer1-box30"><div className="footer1-box5"></div></div>
            <div className="footer1-box6">Na trhu se zaměřujeme na suchou výstavbu, jako je montáž sádrokartonu a suché podlahy nebo i dřevěné podlahy a podhledy.</div>
            <div className="footer1-box7"><a href="https://www.facebook.com/profile.php?id=100091169075261"><img className="footer1-box7-picture4" src={picture4} alt="picture4"/></a></div>
          </div>

          <div className="footer1-box8">
            <div className="footer1-box9">NAVIGACE</div>
            <div className="footer1-box29"><div className="footer1-box10"></div></div>
            <div className="footer1-box11"><Link to="/">Úvod</Link></div>
            <div className="footer1-box12"><Link to="/PageSluzby">Nabídka služeb</Link></div>
            <div className="footer1-box14"><Link to="/PageProjekty">Projekty</Link></div>
            <div className="footer1-box15"><Link to="/PageCertifikaty">Certifikáty</Link></div>
            <div className="footer1-box15"><Link to="/PageKontakt">Kontakt</Link></div>
          </div>

          <div className="footer1-box16">
            <div className="footer1-box17">KONTAKT</div>
            <div className="footer1-box31"><div className="footer1-box18"></div></div>
            <div className="footer1-box19">Volejte během pracovního dne od 8:00 - 17:00. Můžete nás navštívit na adrese Kudlovice 211, Kudlovice, PSČ 687 03, Czech Republic</div>
            <div className="footer1-box20">
             <div className="footer1-box21"><img className="footer1-box21-picture1" src={picture1} alt="picture1"/></div>
             <div className="footer1-box22">+420 702 898 123</div>
            </div>
            <div className="footer1-box23">
             <div className="footer1-box24"><img className="footer1-box21-picture2" src={picture2} alt="picture2"/></div>
             <div className="footer1-box25">Po-Pa 8:00 - 17:00</div>
            </div>
            <div className="footer1-box26">
             <div className="footer1-box27"><img className="footer1-box21-picture3" src={picture3} alt="picture3"/></div>
             <div className="footer1-box28">sadrokartony-zajgla@seznam.cz</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer1;
